import { render, staticRenderFns } from "./mediclist.vue?vue&type=template&id=de9046f4&scoped=true"
import script from "./mediclist.vue?vue&type=script&lang=js"
export * from "./mediclist.vue?vue&type=script&lang=js"
import style0 from "./mediclist.vue?vue&type=style&index=0&id=de9046f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9046f4",
  null
  
)

export default component.exports